module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-10-f8fe91a091251dc5deaea27784a9a5b2.jpg";